<template>
  <div class="container">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="capsula">
      <img alt="Vue logo" src="../assets/dentalia.jpg" />

      <div>
        <b-spinner
          v-if="loaderQR"
          variant="info"
          class="spiner mt-3"
        ></b-spinner>
        <b-row v-if="!loaderQR">
          <Transition name="fade" mode="out-in">
            <b-col v-if="info">
              <b-alert
                v-if="!qrValido"
                class="alerta"
                variant="warning"
                show
              >
                <i class="fa fa-qrcode qr" aria-hidden="true"></i>
                <br />
                <h3>QR INVALIDO</h3>
              </b-alert>
              <b-alert
                v-if="qrValido && !errorPDF"
                class="alerta"
                variant="success"
                show
              >
                <i class="fa fa-qrcode qr" aria-hidden="true"></i>
                <br />
                <h3>QR VALIDO</h3>
              </b-alert>

              <b-alert
                v-if="errorPDF == true"
                class="alerta"
                variant="danger"
                show
              >
                <i class="fa fa-frown-o qr" aria-hidden="true"></i>
                <br />
                <h3>Lo sentimos, no se encontró el archivo</h3>
              </b-alert>
            </b-col>
          </Transition>
        </b-row>
        <b-container fluid>
          <b-row class="mb-4">
            <b-col>
              <div id="loadImg" class="text-center" v-if="loaderPDF">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
              <div
                class="text-center"
                v-if="loaderPDF && rutaDescargar.length >= 1000000"
              >
                <b-progress :max="numPages" class="mb-3" height="2rem">
                  <b-progress-bar
                    :value="numPageCargada"
                    :label="`${((numPageCargada / numPages) * 100).toFixed(
                      2
                    )}%`"
                  ></b-progress-bar>
                </b-progress>
              </div>
              <div>
                <iframe
                  v-if="
                    archivo64 !== undefined &&
                    archivo64 !== null &&
                    archivo64 !== ''
                  "
                  class="archivo-frame"
                  :src="archivo64"
                  onload="document.getElementById('loadImg').style.display='none';"
                />
              </div>
              <div>
                <div
                  id="pdf-fame"
                  v-if="
                    archivo64 !== undefined &&
                    archivo64 !== null &&
                    archivo64 !== ''
                  "
                >
                  <pdf
                    class="archivo-frame"
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                    :src="archivo64"
                    @page-loaded="renderizarPaginas($event)"
                    style="
                      display: inline-block;
                      width: 100%;
                      height: 100%;
                      margin-bottom: 1000px;
                      border: 3px solid #b4b4b4;
                    "
                  ></pdf>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { LoginService } from "@/apiServices/login/LoginService";
export default {
  name: "QRECE",
  components: { pdf },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idQR: null,
    headers: undefined,
    loaderQR: false,
    qrValido: null,
    archivo64: "",
    numPages: 0,
    numPageCargada: 0.5,
    rutaDescargar: "",
    rutaPDF: "",
    namePDF: "",
    rutaFecha: null,
    loaderPDF: false,
    errorPDF: false,
    info: true,
    loginService: new LoginService(),
  }),

  created() {
    this.idQR = this.$route.params.token;
    this.generarToken();
    this.debug = this.$localStorageService.getDebug();
  },

  methods: {
    generarToken() {
      this.loginService
        .login(
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_USER,
          process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_DATO
        )
        .then((response) => {
          this.headers = response.Authentication;
          this.obtenerQR();
        });
    },

    obtenerQR() {
      this.loaderQR = true;
      this.qrValido = false;
      this.$http
        .get(this.$api + "consentimientos/validarQR?idQR=" + this.idQR, {
          headers: { Authorization: this.headers },
        })
        .then((respuesta) => {
          if (respuesta.data.data) {
            let datos = respuesta.data.data;
            this.qrValido = true;
            this.rutaDescargar = Object.values(datos)[0];
            this.rutaFecha = this.$moment(Object.values(datos)[1]).format(
              "YYYY-MM-DD"
            );
            this.verArchivo();
          }
        })
        .finally(() => {
          this.loaderQR = false;
        });
    },

    tratamientoRutas() {
      let palabraAux = "";
      let textoSeparado = this.rutaDescargar.split("/");
      textoSeparado.splice(-1, 1);
      textoSeparado.forEach((element, index) => {
        if (element === "sites") {
          palabraAux = textoSeparado[index + 1];
        }
        if (element != "sites" && element != "" && element != palabraAux) {
          this.rutaPDF += element + "/";
        }
      });

      let palabraAux2 = [];
      let textoSeparado2 = this.rutaDescargar.split("/");
      textoSeparado2.splice(-5, 4);
      palabraAux2 = textoSeparado2;
      palabraAux2.shift("DOCSPRUEBA");
      this.namePDF = palabraAux2.toString();
    },

    verArchivo() {
      this.archivo64 = "";
      this.loaderPDF = true;
      this.tratamientoRutas();
      this.$http
        .get(
          this.$api +
            "sharepoint/descargarArchivo?rutaBase=" +
            this.rutaPDF +
            this.rutaFecha +
            "&nombreArchivo=" +
            this.namePDF,
          {
            headers: { Authorization: this.headers },
          }
        )
        .then((response) => {
          if (this.rutaDescargar !== null && response.data.data !== null) {
            if (this.rutaDescargar.length > 1000000) {
              this.numPages = 0;
              this.numPageCargada = 1;
              let pdfDocument = pdf.createLoadingTask(
                "data:application/pdf;base64," + response.data.data
              );
              pdfDocument.promise.then((pdf) => {
                this.numPages = pdf.numPages;
              });
              this.archivo64 =
                "data:application/pdf;base64," + response.data.data;
            } else {
              this.archivo64 =
                "data:application/pdf;base64," + response.data.data;
            }
            this.info = false;
          }
        })
        .catch((e) => {
          if (e.response.status) {
            this.loaderPDF = false;
            this.errorPDF = true;
            this.$swal({
              position: "center",
              showConfirmButton: false,
              timer: 3500,
              toast: true,
              icon: "error",
              title: "Error al visualizar el PDF",
            });
          }
        })
        .finally(() => {
          this.rutaPDF = "";
          this.namePDF = "";
        });
    },

    renderizarPaginas($event) {
      this.numPageCargada = $event;
      if (
        this.numPageCargada !== undefined &&
        this.numPageCargada !== null &&
        this.numPageCargada > 0
      ) {
        if (this.numPages === $event) {
          this.loaderPDF = false;
        }
      }
    },
  },
};
</script>

<style scoped>
img {
  width: 18%;
  border-radius: 10px;
  margin: 0 auto;
  display: flex;
}

.alerta {
  margin: 20px 0;
}

.qr {
  font-size: 45px;
}

h3 {
  font-size: 15px;
  margin-top: 6px;
}

.container {
  margin-top: 10px;
}

.capsula {
  margin: 0 auto;
  width: 85%;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 20px 30px 0;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.archivo-frame {
  width: 100% !important;
  height: 500px !important;
}

.fade-leave-active {
  transition: opacity 6s ease;
}

.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 900px) {
  img {
    width: 40%;
  }
}
</style>